import wixFullstoryLoader from '@wix/wix-fullstory-loader';
import { ExperimentSpec } from '../../../constants/ExperimentSpec';
import { createLazyFs } from './createLazyFs';
import { areTrackersEnabled } from '../../../monitoring/utils';

const Fs = createLazyFs();

export function runFullStoryLogger(): void {
  if (!areTrackersEnabled()) {
    return;
  }

  wixFullstoryLoader({
    label: 'media-manager-g6',
    spec: ExperimentSpec.FullStory,
  });
}

export function updateFullStoryParams({ metaSiteId }: { metaSiteId?: string }): void {
  Fs.setUserVars({ metaSiteId_str: metaSiteId });
}
